import { api } from "@/v5/lib/api";

export interface HeaderFooterSummary {
  id: string;
  name: string;
}

export interface HeaderFooterDetail {
  header: string;
  footer: string;
}

export interface ContentTemplateSummary {
  id: string;
  name: string;
}

export interface ContentCategory {
  id: string;
  name: string;
  templates: ContentTemplateSummary[];
}

export interface ContentTemplateDetail {
  content: string;
  subject: string;
}

export interface MostUsedTemplate {
  id: string;
  name: string;
  useCount: number;
}

export async function fetchHeaderFooterList(): Promise<HeaderFooterSummary[]> {
  const data = await api<{ headers: HeaderFooterSummary[] }>("/email-templates/headers");
  return data.headers ?? [];
}

function buildContextQuery(patientID?: string, planID?: string): string {
  const qs = new URLSearchParams();
  if (patientID) qs.set("patientID", patientID);
  if (planID) qs.set("planID", planID);
  return qs.toString() ? `?${qs.toString()}` : "";
}

export async function fetchHeaderFooter(
  id: string,
  patientID?: string,
  planID?: string,
): Promise<HeaderFooterDetail> {
  const params = buildContextQuery(patientID, planID);
  return api<HeaderFooterDetail>(`/email-templates/headers/${encodeURIComponent(id)}${params}`);
}

export async function fetchContentList(): Promise<ContentCategory[]> {
  const data = await api<{ categories: ContentCategory[] }>("/email-templates/content");
  return data.categories ?? [];
}

export async function fetchContentTemplate(
  id: string,
  patientID?: string,
  planID?: string,
): Promise<ContentTemplateDetail> {
  const params = buildContextQuery(patientID, planID);
  return api<ContentTemplateDetail>(`/email-templates/content/${encodeURIComponent(id)}${params}`);
}

export async function fetchContentMostUsed(): Promise<MostUsedTemplate[]> {
  const data = await api<{ templates: MostUsedTemplate[] }>(
    "/email-templates/content/most-used",
  );
  return data.templates ?? [];
}

export async function resetContentMostUsed(id: string): Promise<void> {
  await api(`/email-templates/content/most-used/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
